import { memo } from "react";
import styles from "./ResultBox.module.css";

const AdminAddresses = ({ Address, setAddress, setLocation, addAddress }) => {
  const changeValue = (e) => {
    if (e.target.name === "latitude" || e.target.name === "longitude") {
      setAddress((prev) => ({
        ...prev,
        [e.target.name]: parseFloat(e.target.value),
      }));
    }
    setAddress((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  return (
    <div className={styles.wrapperEditBox}>
      {!addAddress && (
        <>
          <div className={styles.line}>
            <label className={styles.label} htmlFor="raw">
              Raw Address:
            </label>
            <input
              className={styles.input}
              value={Address.raw_address}
              name="raw_address"
              id="raw"
              onChange={changeValue}
            />
          </div>
          <div className={styles.line}>
            <label className={styles.label} htmlFor="clean">
              Clean Address:
            </label>
            <input
              className={styles.input}
              value={Address.clean_address}
              name="clean_address"
              id="clean"
              onChange={changeValue}
            />
          </div>
          <div className={styles.line}>
            <label className={styles.label} htmlFor="main">
              Main Address:
            </label>
            <input
              className={styles.input}
              value={Address.main_address}
              name="main_address"
              id="main"
              onChange={changeValue}
            />
          </div>
          <div className={styles.line}>
            <label className={styles.label} htmlFor="keyword_address">
              Keyword Address:
            </label>
            <input
              className={styles.input}
              value={Address.keyword_address}
              name="keyword_address"
              id="keyword_address"
              onChange={changeValue}
            />
          </div>
          <div className={styles.line}>
            <label className={styles.label} htmlFor="exact">
              Exact Address:
            </label>
            <input
              className={styles.input}
              value={Address.exact_address}
              name="exact_address"
              id="exact"
              onChange={changeValue}
            />
          </div>
        </>
      )}
      {addAddress && (
        <div className={styles.line}>
          <label className={styles.label} htmlFor="exact">
            Address:
          </label>
          <input
            className={styles.input}
            value={Address.address}
            name="address"
            id="address"
            onChange={changeValue}
          />
        </div>
      )}
      <div className={styles.line}>
        <input
          className={[styles.input, styles.ltr].join(" ")}
          value={Address.latitude}
          name="latitude"
          id="latitude"
          onChange={changeValue}
        />
        &nbsp; &nbsp;
        <input
          className={[styles.input, styles.ltr].join(" ")}
          value={Address.longitude}
          name="longitude"
          id="longitude"
          onChange={changeValue}
        />
        <div onClick={setLocation} className={styles.setLocationButton}>
          Show Location
        </div>
      </div>
    </div>
  );
};

export default memo(AdminAddresses);
